import React from "react";
import styled from "styled-components";
import TextF8 from "../TextF8";
import TextF6 from "../TextF6";
import Box from "../Box";
import { themeGet } from "styled-system";
import { SmallContainer } from "../Grid";
import SubmitButton from "../SubmitButton";
import { injectIntl, FormattedMessage } from "react-intl";


const TextF6Regular = styled(TextF6)`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  font-weight: normal;
`;

const Wrapper = styled.div`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;

const QuizInner = styled(Box)`
  background: #f6f4f4;
  padding-top: 5rem;
  margin-bottom: 6rem;
`;

const Essay = styled.div``;

const Description = styled.div`
  padding: 2rem;
`;

const WordCount = styled(TextF6)`
  padding-top: 0;
  margin: 0;
`;

const Header = styled.div`
  background-color: #4844a3;
`;

const Name = styled.div`
  font-family: "Roboto";
  font-size: 1.5rem;
  padding: 2rem;
  color: white;
`;

const TextArea = styled.textarea`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  color: #29264c;
  width: 100%;
  margin-top: 0;
  padding: 1.5rem;
  font-size: 1rem;
  border: 1px solid rgba(72, 68, 163, 1);
  border-radius: 0;
  margin-bottom: 2rem;
  border-radius: 0.5rem;
  outline: none;
  background-clip: padding-box;
`;

const TextContainer = styled(Box)`
  padding: 2rem 2rem;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  color: 29264c;
  white-space: pre-wrap;
  font-size: 1rem;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

const Answer = styled(TextF8)`
  margin-top: 0;
  font-weight: normal;
  margin: 0.5rem 0;
  padding: 4px 16px;
  border-left: 4px solid ${props =>
    props.correctAnswer ? "#19CA94" : "#E02C00"}
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

class Widget extends React.Component {
  constructor() {
    super();
    this.state = {
      wordCount: 0
    };
  }

  componentDidMount() {
    this.setState({
      wordCount: 0 //!!this.props.answer ? this.wordCount(this.props.answer.data) : 0
    });
  }

  render() {
    return (
      <div>
        <Box bg="#EBE9EF" py={5}>
          {!!this.props.rejectedAnswer ? (
            <SmallContainer>
              <Box py={5}>
                <TextF6 mt={0} mb={2}>
                  <FormattedMessage id="quiz.message.rejectedInReview" />
                </TextF6>
                <TextContainer mt={0} mb={2}>
                  <TextF6Regular m={0}>
                    {this.props.rejectedAnswer.data}
                  </TextF6Regular>
                </TextContainer>
              </Box>
            </SmallContainer>
          ) : null}
          {!this.props.submitted ? (
            <SmallContainer>
              <TextArea
                onChange={this.onChange.bind(this)}
                value={this.props.answer}
                rows="7"
                placeholder={`${this.props.intl.formatMessage({
                  id: "quiz.yourAnswer"
                })}`}
                innerRef={node => {
                  this.textArea = node;
                }}
              />
              <Box
                display="flex"
                justifyContent="space-between"
                align-items="start"
              >
                <WordCount>
                  <FormattedMessage id="quiz.words" />{" "}
                  {this.wordCount(this.props.answer)}
                </WordCount>
                <SubmitButton
                  onSubmit={() => this.onSubmit()}
                  submitted={this.props.submitted}
                  submitting={this.props.submitting}
                  disabled={this.isEmptyAnswer()}
                />
              </Box>
            </SmallContainer>
          ) : (
            <SmallContainer>
              <TextF6 mt={0} mb={2}>
                <FormattedMessage id="quiz.youAnswered" />
              </TextF6>
              <TextContainer mt={0} mb={5}>
                <TextF6Regular m={0}>{this.props.answer}</TextF6Regular>
              </TextContainer>
              {!!this.props.messages ? (
                <div>
                  <TextF6 mt={0} mb={2}>
                    <FormattedMessage id="quiz.exampleAnswer" />
                  </TextF6>
                  <Answer correctAnswer={true}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.props.messages.message
                      }}
                    />
                  </Answer>
                </div>
              ) : null}
            </SmallContainer>
          )}
        </Box>
      </div>
    );
  }

  isEmptyAnswer() {
    return !this.textArea || this.textArea.value.trim() === "";
  }

  onSubmit() {
    this.props.onSubmit(this.textArea.value.trim());
  }

  onChange(event) {
    this.props.onChange(event.target.value);
    this.setState({
      wordCount: this.wordCount(event.target.value)
    });
  }

  wordCount(text) {
    if (!text || text === "" || !text.length) {
      return 0;
    }
    const wordArray = text.trim().split(/[ \n]+/);
    let words;
    if (wordArray.length === 1 && wordArray[0] === "") {
      words = 0;
    } else {
      words = wordArray.length;
    }
    return words;
  }
}

export default injectIntl(Widget);
